import {DateTime} from "../../time/DateTime";
import React from "react";

export const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload
        const date = DateTime.fromSeconds(data.date).toLondonTimeZone().toFormat('MMM dd HH:mm a')
        return (
            <div data-testid="custom-tooltip" className="custom-tooltip">
                <p>Time: {date}</p>
                <p>Power: {data.power.toFixed(3)} MW</p>
                {data.expected !== undefined && (
                    <p>Expected: {data.expected.toFixed(3)} MW</p>
                )}
                {data.baseline !== undefined && (
                    <p>Baseline: {data.baseline.toFixed(3)} MW</p>
                )}
            </div>
        )
    }
    return null
}